import React from 'react';
import { Button } from './ui/Button';
import { Check, Clock, Shield } from 'lucide-react';
export function OfferSection() {
  const bullets = ['Guía digital completa', 'Checklist de mochila sensorial', 'Plan de acción de 60 segundos', 'Diario de disparadores', 'Tarjeta visual imprimible'];
  return <section id="offer-section" className="bg-white py-14 md:py-24 px-5 scroll-mt-4" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <div className="bg-[#FDF8F0] rounded-[2rem] p-6 md:p-12 border-2 border-[#D4A853]/30 shadow-xl relative" data-id="element-115">
          {/* Badge */}
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#C75C3A] text-white px-6 py-1.5 rounded-full text-xs md:text-sm font-bold tracking-wide shadow-md whitespace-nowrap" data-id="element-116">
            PRECIO BETA DE LANZAMIENTO
          </div>

          <div className="text-center space-y-6 mt-4" data-id="element-117">
            <h2 className="text-2xl md:text-4xl font-bold text-[#2D1F0E] leading-tight" data-id="element-118">
              Recupera la calma de tus salidas por solo $6.49
            </h2>

            <p className="text-base md:text-lg text-[#6B5D4F] max-w-xl mx-auto" data-id="element-119">
              Accede hoy mismo al Protocolo SOS completo con herramientas
              prácticas para actuar con más calma, claridad y confianza.
            </p>

            <div className="py-6 flex flex-col items-center justify-center bg-white rounded-2xl border border-[#D4A853]/20 mx-auto max-w-sm" data-id="element-120">
              <div className="text-[#6B5D4F] text-sm md:text-base line-through mb-1" data-id="element-121">
                Precio Regular: $12.99
              </div>
              <div className="flex items-start justify-center text-[#C75C3A]" data-id="element-122">
                <span className="text-3xl font-bold mt-1" data-id="element-123">$</span>
                <span className="text-6xl md:text-7xl font-black tracking-tighter" data-id="element-124">
                  6.49
                </span>
              </div>
              <div className="text-[#4A6741] text-sm font-medium mt-3 bg-[#F0F4EC] px-3 py-1 rounded-full" data-id="element-125">
                Pago único • Acceso inmediato
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 text-[#C75C3A] font-medium text-sm md:text-base bg-[#C75C3A]/10 py-2 px-4 rounded-full w-fit mx-auto" data-id="element-126">
              <Clock className="w-4 h-4" data-id="element-127" />
              <span data-id="element-128">Disponible por las próximas 48 horas</span>
            </div>

            <div className="text-left max-w-sm mx-auto space-y-3 py-4" data-id="element-129">
              {bullets.map((bullet, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-130">
                  <Check className="w-5 h-5 text-[#4A6741] flex-shrink-0" data-id="element-131" />
                  <span className="text-[#2D1F0E] font-medium text-sm md:text-base" data-id="element-132">
                    {bullet}
                  </span>
                </div>)}
            </div>

            <div id="offer-cta" className="pt-4 space-y-4" data-id="element-133">
              <Button fullWidth href="https://www.upreferr.com/cart/44203439128711:1" className="text-lg md:text-xl py-5 min-h-[56px] shadow-lg" data-id="element-134">
                Quiero el Protocolo SOS ahora
              </Button>

              <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-[#6B5D4F] font-medium" data-id="element-135">
                <Shield className="w-4 h-4" data-id="element-136" />
                <span data-id="element-137">
                  Compra segura • Acceso inmediato • Material en español
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}